import { render, staticRenderFns } from "./myStudent.vue?vue&type=template&id=dd79fd56&"
import script from "./myStudent.vue?vue&type=script&lang=js&"
export * from "./myStudent.vue?vue&type=script&lang=js&"
import style0 from "./myStudent.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports